import React, { useContext } from "react";
import classes from "./Toast.module.scss";
import { ToastContext } from "../../store/toast-context";

const ToastContainer = () => {
  const { toasts, dismissToast } = useContext(ToastContext);

  if (!toasts.length) return null;

  return (
    <section className={classes.toast_container} role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${classes.toast} ${classes[toast.type] || classes.error}`}
          onClick={() => dismissToast(toast.id)}
        >
          {toast.message}
        </div>
      ))}
    </section>
  );
};

export default ToastContainer;
